/* ond-band-dr.js (18-10-2026, thẻ #2) — chạy khung 3D trong mỗi thẻ [data-odb] theo vị trí cuộn của chính thẻ đó.
 * Tiến độ 0 khi đỉnh thẻ ở 92 % chiều cao màn → 1 khi đỉnh thẻ ở 30 % (khung cuối, đủ nhãn, giữ nguyên khi đọc tiếp).
 * Nạp mỗi khung thứ 2 (18/36), 960 px desktop · 720 px điện thoại, chỉ khi thẻ cách màn ≤ 1,5 màn. Vẽ khung gần nhất ĐÃ nạp (không chờ).
 * reduce-motion / saveData / 2g / RAM ≤ 1 GB: không làm gì → ảnh tĩnh khung cuối. Không nút Pause/Skip (anh 17-10). */
(() => {
  if (window.__odb) return; window.__odb = 1;
  const mm = (q) => window.matchMedia && matchMedia(q).matches;
  const c = navigator.connection || {};
  if (mm('(prefers-reduced-motion: reduce)') || c.saveData || /(^|-)2g$/.test(c.effectiveType || '') || (navigator.deviceMemory || 8) <= 1) return;
  const W = mm('(max-width: 749px)') ? 720 : 960, STEP = 2;
  const S = new Map();
  const pad = (n) => String(n).padStart(3, '0');
  function setup(card) {
    if (S.has(card)) return S.get(card);
    const base = card.dataset.base, first = +card.dataset.first || 1, n = +card.dataset.count || 36;
    const cv = card.querySelector('canvas'); if (!cv || !base) return null;
    const idx = []; for (let i = 0; i < n; i += STEP) idx.push(first + i);
    if (idx[idx.length - 1] !== first + n - 1) idx.push(first + n - 1);
    cv.width = cv.height = W;
    const s = { card, cv, ctx: cv.getContext('2d'), idx, imgs: new Array(idx.length).fill(null), base, shown: -1, want: 0, loaded: false };
    S.set(card, s); return s;
  }
  function draw(s) {
    let j = s.want; while (j >= 0 && !s.imgs[j]) j--;
    if (j < 0) return;
    if (j === s.shown) return;
    s.ctx.drawImage(s.imgs[j], 0, 0, W, W); s.shown = j;
    if (!s.card.classList.contains('is-live')) s.card.classList.add('is-live');
  }
  function load(s) {
    if (!s || s.loaded) return; s.loaded = true;
    s.idx.forEach((f, k) => {
      const im = new Image(); im.decoding = 'async';
      im.onload = () => { s.imgs[k] = im; draw(s); };
      im.src = `${s.base}${pad(f)}.webp?width=${W}`;
    });
  }
  let raf = 0;
  function tick() {
    raf = 0; const vh = innerHeight;
    S.forEach((s) => {
      if (!s.loaded) return;
      const r = s.card.getBoundingClientRect();
      if (r.bottom < -80 || r.top > vh + 80) return;
      const p = Math.min(1, Math.max(0, (vh * 0.92 - r.top) / (vh * 0.62)));
      s.want = Math.round(p * (s.idx.length - 1)); draw(s);
    });
  }
  const queue = () => { if (!raf) raf = requestAnimationFrame(tick); };
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { load(setup(e.target)); queue(); } }), { rootMargin: '150% 0px' }) : null;
  const watch = () => document.querySelectorAll('[data-odb]').forEach((card) => { if (setup(card)) { if (io) io.observe(card); else { load(S.get(card)); } } });
  watch();
  addEventListener('scroll', queue, { passive: true });
  addEventListener('resize', queue, { passive: true });
  document.addEventListener('shopify:section:load', () => { watch(); queue(); });
  queue();
})();
